<ng-container [editableInStoryblok]="_editable">
	<vp-banner [variant]="variant">
		<sb-richtext
			[content]="content"
			[maxWidth]="'max-w-screen-lg'"
			richTextAlignment="text-center"
		/>
	</vp-banner>
</ng-container>
